import request from '../request'

//五条最新发送消息
export function getLastMessage_FS(data) {
    return request({
        url: '/message/indexMessage?type=1',
        method: 'get',
        params: data
    })
}

//五条最新接收消息
export function getLastMessage_JS(data) {
    return request({
        url: '/message/indexMessage?type=0',
        method: 'get',
        params: data
    })
}

//最新位置
export function getLastLocation(data) {
    return request({
        url: '/location/indexLocation',
        method: 'get',
        params: data
    })
}